/**
 * Account roles used to pick the Hub variant and the Family screen copy.
 * Mirrors the accountType field the PDS stores on profiles.
 */
export type HubRole = 'creator' | 'learner' | 'parent'

export function roleOf(accountType: unknown): HubRole {
  if (accountType === 'creator' || accountType === 'organisation') {
    return 'creator'
  }
  if (accountType === 'parent') return 'parent'
  return 'learner'
}
